import script from "./CopyButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CopyButton.vue?vue&type=script&lang=ts&setup=true"

import "./CopyButton.vue?vue&type=style&index=0&id=8adb87f4&lang=scss&scoped=true"
import "./CopyButton.vue?vue&type=style&index=1&id=8adb87f4&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8adb87f4"]])

export default __exports__